import moment from 'moment-timezone-all'

export const START_OF_REPORTS = moment('2017-12-01T00:00:00')
